__turbopack_context__.v({
  "dark": "Dimmer-module-scss-module__BOsvYW__dark",
  "dimmer": "Dimmer-module-scss-module__BOsvYW__dimmer",
});
